// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"640":"4c5c7a5b","950":"9306d01b"}[chunkId] + ".chunk.js";
};